import { smartHttp } from 'smart-core-util'
import { Toast } from 'mint-ui'//Indicator
var axios = new smartHttp({
    alert: Toast,
    // block: Indicator.open,
    // unblock: Indicator.close
}).api;
export default axios;

/**  axios
 * 更多详情见axios文档
 * zn: https://www.kancloud.cn/yunye/axios/234845
 * io: https://www.npmjs.com/package/axios
 */

// import axios from 'axios'
// import qs from 'qs'
// import {Toast, MessageBox} from 'mint-ui'

// import store from '@/store/store';
// import apiConfig from './axiosConfig'

/** axios默认全局配置 */

// axios.defaults.baseURL = apiConfig.baseUrl
// axios.defaults.timeout = 30000
// axios.defaults.headers.post['Content-Type'] = 'application/json; charset=utf-8'

/** axios拦截器 */

// 添加请求拦截器
// axios.interceptors.request.use(
  // 请求发送前进行处理
//   (request) => {
//     store.commit('changeLoadingStatus', {isShow: true})
//     if (request.data && request.headers['Content-Type'] === 'application/x-www-form-urlencoded') {
//       request.data = qs.stringify(request.data)
//     }
//     let token = "eyJhbGciOiJSUzI1NiIsImtpZCI6IjQ1OTU0ZTUzMjgxN2Q1NTM5ZTU5YTA4NmRlNDFhMmZhIiwidHlwIjoiSldUIn0.eyJuYmYiOjE1Mjc0NzQ0MzMsImV4cCI6MTU1ODU3ODQzMywiaXNzIjoiaHR0cDovL3Bhc3Nwb3J0LmRldi5zbWFydHhjbG91ZC5jbiIsImF1ZCI6WyJodHRwOi8vcGFzc3BvcnQuZGV2LnNtYXJ0eGNsb3VkLmNuL3Jlc291cmNlcyIsIkFwaXMuQWRtaW4iLCJBcGlzLkNoZWNrQWNjb3VudCIsIkFwaXMuQ29uZmlndXJhdGlvbiIsIkFwaXMuRXZlbnQiLCJBcGlzLkZpbGUiLCJBcGlzLkZsb3ciLCJBcGlzLkZvdW5kYXRpb24iLCJBcGlzLklkZW50aXR5IiwiQXBpcy5JbnZvaWNlIiwiQXBpcy5NZWFsIiwiQXBpcy5NZXNzYWdlIiwiQXBpcy5NeVByb2ZpbGUiLCJBcGlzLlNob3BLZWVwZXIiLCJBcGlzLlNtYXJ0QWxpcGF5IiwiQXBpcy5TbWFydEV2ZW50IiwiQXBpcy5TbWFydEpvYi5GaW4iLCJBcGlzLlZlbnVlIiwiZWMub3JkZXIiLCJwYXNzcG9ydCIsInNtYXJ0eGFwcCIsIndvcmtmbG93Il0sImNsaWVudF9pZCI6InNpdGVzLnBhc3Nwb3J0Iiwic3ViIjoiNjlmNThmNDEtNDZmYi00OTFhLTk0YjMtNzM4MDdkN2MwNDAyIiwiYXV0aF90aW1lIjoxNTI3NDc0NDMzLCJpZHAiOiJsb2NhbCIsImlkIjoiNjlmNThmNDEtNDZmYi00OTFhLTk0YjMtNzM4MDdkN2MwNDAyIiwibmFtZSI6ImhoayIsIm5pY2tuYW1lIjoi5Lya5b6I6YW3Iiwicm9sZV9jb2RlcyI6IkVYLk1vbnRobHkuU21hcnRKb2IsRVguU3VwcGxpZXIiLCJ0ZW5hbnRfaWQiOiJlMTUyMjY2Ni1kOTA0LTQzOGUtODRiMC05MDlhYTZhZTA1MzMiLCJ0ZW5hbnRfY29kZSI6InBmaXplciIsInN1cHBsaWVySWQiOiIyNmFlMzE2OC01YWE3LTRkNzQtOWQ2OC03N2YyNDQ0NDA3ZGYiLCJ2ZXJzaW9uIjoiOTk5OSIsInNjb3BlIjpbIkFwaXMuQWRtaW4iLCJBcGlzLkNoZWNrQWNjb3VudCIsIkFwaXMuQ29uZmlndXJhdGlvbiIsIkFwaXMuRXZlbnQiLCJBcGlzLkZpbGUiLCJBcGlzLkZsb3ciLCJBcGlzLkZvdW5kYXRpb24iLCJBcGlzLklkZW50aXR5IiwiQXBpcy5JbnZvaWNlIiwiQXBpcy5NZWFsIiwiQXBpcy5NZXNzYWdlIiwiQXBpcy5NeVByb2ZpbGUiLCJBcGlzLlNob3BLZWVwZXIiLCJBcGlzLlNtYXJ0QWxpcGF5IiwiQXBpcy5TbWFydEV2ZW50IiwiQXBpcy5TbWFydEpvYi5GaW4iLCJBcGlzLlZlbnVlIiwiZWMub3JkZXIiLCJwYXNzcG9ydCIsInNtYXJ0eGFwcCIsIndvcmtmbG93Iiwib2ZmbGluZV9hY2Nlc3MiXSwiYW1yIjpbImN1c3RvbSJdfQ.sIVoYdn1cMUbNCOUN48xGW6OZwjtuoat1bt50j0D98Au1ky6c4Wa8ImOqnJ90vAh7dIV6hSpGIaHdr1ZffnoFASl-0xEkdR9ifluXBwxUFtZg3oqoQHPjQPxz9AvMTIGp-wxhgVacE7EI7GyUUzZqxFDMQx8IVKEHhk-o-ptfdJBYcacIeZXwsTnBb_-wrXZJ8Wz1vOZPJg7PEbvBS9_PYHLdL5hc0MVA52N-_p4XqOUtwkY75GvUQP76L_siBh2rrjVU4yHseA5SWM2D0WCmCWHqK8DPsjF6FSz1zTYi6Vfoo9CCaly--8gWf7Ekv-_lBpMqlyPYhIsKnDswSvyPA"
//     if (token && token != null) {
//       request.headers['Authorization'] = 'Bearer ' + token
//     }
//     return request
//   // 请求错误时处理
//   }, (eror) => {
//     store.commit('changeLoadingStatus',{isShow: false})
//     return eror
//   }
// )

// 添加响应拦截器
// axios.interceptors.response.use(
  // 获取响应数据进行处理
  // (response) => {
  //   store.commit('changeLoadingStatus',{isShow: false})
  //   if (response.data && response.data.success == false && !response.data.access_token) {
  //       Toast(response.msg || response.data.msg || '未知错误')
  //       return response
  //   }
  //   return response.data;

  // 响应失败时处理
  // }, (error) => {
    // console.log(error.response)
//     if (error.response) {
//       var result = error.response.data || { error_description: "未知错误" };
//       switch (error.response.status) {
//           case 400:
//               Toast(result.error_description || result.message || "未知错误")
//               break;
//           case 401:
//               Toast("授权失败,请重新登录");
//               break;
//           case 404:
//               Toast(error.response.statusText || "未知错误")
//               break;
//           case 500:
//               Toast(result.error_description || result.message || "服务器偷懒了,请稍后重试")
//               break;
//       }
//     }
//     store.commit('changeLoadingStatus',{isShow: false})
//     return error
//   },

// )

// export default axios



// WEBPACK FOOTER //
// ./src/api/axios.js